import getLogo from '@/services/general/getLogo';

async function genererLogoSociete(societeTab) {
  const promises = [];
  for (let i = 0; i < societeTab.length; i += 1) {
    promises.push(getLogo(societeTab[i].societeId));
  }
  const allLogo = await Promise.all(promises);
  for (let i = 0; i < societeTab.length; i += 1) {
    societeTab[i].logo = allLogo[i];
  }
  return societeTab;
}

export default function genererTableauSociete(userInformation, societes = []) {
  const societeTab = [];
  const societeIds = societes.map(s => s.id);
  userInformation.agences.forEach((agence) => {
    agence.selected = false;
    if (agence.agenceId === userInformation.agence.agenceId) {
      agence.selected = true;
    }
    const societeFound = societeTab.find((societe) => {
      return societe.societeId === agence.societeId;
    });
    if (societeFound === undefined) {
      const newSociete = {
        societeId: agence.societeId,
        libelleSociete: agence.libelleSociete,
        codeSociete: agence.codeSociete,
        agences: [],
      };
      newSociete.agences.push(agence);
      if (societeIds.includes(newSociete.societeId)) {
        societeTab.push(newSociete);
      }
    } else {
      societeFound.agences.push(agence);
    }
  });
  return genererLogoSociete(societeTab);
}
